<template>
  <div class="serviceList">
    <div class="itemList">
      <el-select v-model="leftValue" style="margin-left:10px;" aria-placeholder="请选择"  @change="selectChannel">
        <el-option
          v-for="(item) in allChannel"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
/**
 * @param channel：被选中服务商
 * @param choose-channel: function，选择服务商传递函数
 * 调用示例: <serviceList :channel='xx' @choose-channel='xx'></serviceList>
 */
import { initOptions } from '@/utils/constant'

export default {
  name: 'serviceList',
  props: {
    backColor: String,
    type: String,
    selectChannels: Array,
    chartParam: Object
  },
  data() {
    return {
      rightValue: this.chartParam.rightValue,
      leftValue: this.chartParam.leftValue,
      allChannel: initOptions
    }
  },
  methods: {
    findName(e) {
      if (this.type && this.type === 'timeOrgTerm') {
        return initOptions.filter(item => item.value === e)
      } else {
        return this.allChannel.filter(item => item.value === e)
      }
    },
    selectChannel() {
      const obj = {
        leftValue: this.leftValue,
        rightValue: this.rightValue
      }
      const leftName = this.findName(this.leftValue);
      const rightName = this.findName(this.rightValue);
      const objName = {
        leftName: leftName && leftName.length > 0 ? leftName[0].name : '',
        rightName: rightName && rightName.length > 0 ? rightName[0].name : ''
      }
      this.$emit('choose-channel', obj);
      this.$emit('choose-name', [objName.leftName, objName.rightName])
    }
  },
  watch: {
    selectChannels: {
      handler(newVal) {
        if (newVal && newVal.length && this.type === 'timeOrgTerm') {
          this.leftValue = newVal[0].value || 'user_cnt'
          this.rightValue = newVal.length > 1 ? newVal[1].value : null
          this.allChannel = newVal
        }
      }
    },
    deep: true
  }
};
</script>

<style lang="less" scoped>
  .serviceList {
    .itemList{
      display: inline-block;
      margin-right: 10px;
    }
  }
</style>
